import React, { useEffect, useState } from "react";
import "./css/contact.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [submitError, setSubmitError] = useState("");

  const [content, setContent] = useState({
    headerSmall: "تواصل مع نبض كير",
    headerTitleLine1: "نحن في نبض كير هنا لمساعدتك",
    headerTitleLine2: "في تنمية أعمالك",
    descriptionText:
      "فريق نبض كير متاح للإجابة على جميع استفساراتك المتعلقة بالخدمات الاستشارية والتخليص الجمركي. لا تتردد في الاتصال بنا أو زيارتنا.",
    addressText: "الرياض، المملكة العربية السعودية\nطريق الملك فهد، برج العليا",
    phonePrimary: "+966573394229",
    phoneSecondary: "+966573394229",
    emailAddress: "info@nabdh-ksa.com",
    services: [
      { value: "fda", label: "هيئة الغذاء والدواء" },
      { value: "industry", label: "تراخيص صناعية" },
      { value: "customs", label: "تخليص جمركي" },
      { value: "other", label: "استشارة عامة" },
    ],
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/contact-content`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.contact) {
          setContent((prev) => ({
            ...prev,
            ...data.contact,
          }));
        }
      } catch {
        // fall back to defaults
      }
    };

    fetchContent();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitMessage("");
    setSubmitError("");

    try {
      const res = await fetch(`${API_BASE_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || "حدث خطأ أثناء إرسال الرسالة.");
      }

      setSubmitMessage("تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.");
      setFormData({
        name: "",
        phone: "",
        email: "",
        service: "",
        message: "",
      });
    } catch (err) {
      setSubmitError(err.message || "حدث خطأ أثناء إرسال الرسالة.");
    } finally {
      setSubmitting(false);
    }
  };

  const servicesOptions = Array.isArray(content.services) ? content.services : [];
  const addressLines = (content.addressText || "").split("\n");

  return (
    <section className="contact-section">
      <div className="container contact-content-wrapper">
        <div className="row">
          {/* 1. Contact Info Column (Right Side) */}
          <div className="col-lg-5 col-md-12">
            <div className="contact-info-box">
              <div className="contact-header">
                <h6>{content.headerSmall}</h6>
                <h2>
                  {content.headerTitleLine1} <br /> {content.headerTitleLine2}
                </h2>
              </div>

              <p className="contact-info-desc">{content.descriptionText}</p>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div className="info-text">
                  <h5>موقعنا</h5>
                  <p>
                    {addressLines.map((line, idx) => (
                      <span key={idx}>
                        {line}
                        {idx < addressLines.length - 1 && <br />}
                      </span>
                    ))}
                  </p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div className="info-text">
                  <h5>اتصل بنا</h5>
                  {content.phonePrimary && (
                    <>
                      <a href={`tel:${content.phonePrimary}`}>{content.phonePrimary}</a>
                      <br />
                    </>
                  )}
                  {content.phoneSecondary && (
                    <a href={`tel:${content.phoneSecondary}`}>{content.phoneSecondary}</a>
                  )}
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div className="info-text">
                  <h5>البريد الإلكتروني</h5>
                  {content.emailAddress && (
                    <a href={`mailto:${content.emailAddress}`}>{content.emailAddress}</a>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* 2. Contact Form Column (Left Side) */}
          <div className="col-lg-7 col-md-12">
            <div className="contact-form-card">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Name */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">الاسم الكامل</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control-custom"
                        placeholder="أدخل اسمك هنا"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">رقم الهاتف</label>
                      <input
                        type="tel"
                        name="phone"
                        className="form-control-custom"
                        placeholder="05xxxxxxxx"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">البريد الإلكتروني</label>
                      <input
                        type="email"
                        name="email"
                        className="form-control-custom"
                        placeholder="name@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Service Selection */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">نوع الخدمة المطلوبة</label>
                      <select
                        name="service"
                        className="form-control-custom"
                        value={formData.service}
                        onChange={handleChange}
                      >
                        <option value="">اختر الخدمة...</option>
                        {servicesOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Message */}
                  <div className="col-12">
                    <div className="form-group">
                      <label className="form-label">تفاصيل الرسالة</label>
                      <textarea
                        name="message"
                        className="form-control-custom"
                        placeholder="اكتب تفاصيل استفسارك هنا..."
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                  </div>

                  {/* Status */}
                  {submitMessage && (
                    <div className="col-12">
                      <p style={{ color: "#16a34a", marginTop: "0.5rem" }}>{submitMessage}</p>
                    </div>
                  )}
                  {submitError && (
                    <div className="col-12">
                      <p style={{ color: "#f97373", marginTop: "0.5rem" }}>{submitError}</p>
                    </div>
                  )}

                  {/* Submit Button */}
                  <div className="col-12">
                    <button type="submit" className="submit-btn" disabled={submitting}>
                      {submitting ? "جاري الإرسال..." : "إرسال الطلب"}
                      <i className="fa-solid fa-paper-plane"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;